export const getScrollContainer = () => {
    return (document.scrollingElement || document.documentElement);
};
//# sourceMappingURL=getScrollContainer.js.map